// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import { transformResponse } from '@utilities/api';
import fetchBaseQuery from '@utilities/fetchBaseQuery';

// Define a service using a base URL and expected endpoints
export const locationApi = createApi({
  reducerPath: 'locationApi',
  tagTypes: ['Location'],
  baseQuery: fetchBaseQuery,
  endpoints: (builder) => ({
    /**
     * Get locations
     */
    getLocations: builder.query({
      query: () => `locations`,
      transformResponse,
      providesTags: (result) =>
        result
          ? result.map(({ id }) => ({ id, type: 'Location' }))
          : ['Location'],
    }),

    /**
     * Get specific location
     */
    getLocation: builder.query({
      query: (uid) => `locations/${uid}`,
      transformResponse,
      providesTags: ({ uid }) => [{ type: 'Location', id: uid }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLocationsQuery, useGetLocationQuery } = locationApi;
